export const queryKeys = {
  races: {
    _def: ['races'],
    all: (params) => ['races', params ?? {}],
    detail: (id) => ['races', 'detail', id],
    types: (raceId) => ['races', raceId, 'types'],
  },
  registrations: {
    _def: ['registrations'],
    all: () => ['registrations'],
    byRace: (raceId) => ['registrations', 'race', raceId],
  },
  results: {
    _def: ['results'],
    list: (raceId: any, params?: any) => ['results', raceId, params ?? {}],
    teams: (raceId: any, params?: any) => ['results', 'teams', raceId, params ?? {}],
    summary: (raceId) => ['results', 'summary', raceId],
  },
  organizers: {
    _def: ['organizers'],
    all: () => ['organizers'],
    detail: (id) => ['organizers', 'detail', id],
  },
  posts: {
    _def: ['posts'],
    all: () => ['posts'],
    detail: (id) => ['posts', 'detail', id],
  },
  discounts: {
    _def: ['discounts'],
    all: (raceId) => ['discounts', raceId],
    everything: () => ['discounts', 'all'],
  },
  sponsors: {
    _def: ['sponsors'],
    all: (raceId) => ['sponsors', raceId],
  },
  tshirtSizes: {
    _def: ['tshirtSizes'],
    all: (raceId, raceTypeId) => ['tshirtSizes', raceId, raceTypeId ?? null],
  },
  series: {
    _def: ['series'],
    all: () => ['series'],
    detail: (id) => ['series', 'detail', id],
  },
  dashboard: {
    stats: () => ['dashboard', 'stats'],
  },
};
